<template>
  <!-- eslint-disable vue/no-unused-vars -->
  <div class="view-container text-center" style="min-width: 95%;">
    <div class="text-right cursor-pointer">
      <b-button variant="link" @click="back">
        <font-awesome-icon icon="times" />
      </b-button>
    </div>
    <!-- <h3>Avvisi pagamento degli ultimi tre anni non pagati o pagati parzialmente</h3> -->

    <loading-spinner v-if="loading" />
    <div v-else-if="$store.getters.isAuthenticated" class="row justify-content-between mx-2 align-middle">
    </div>
    <div v-if="!loading">
      <h1>Estratto conto</h1>
      <h4 style="float: left;">Storico contratti</h4>
    </div>
    <b-alert v-if="!loading && !datiGeneraliItems.length" show variant="info" class="my-4">
      Non ci sono movimenti da visualizzare.
    </b-alert>

    <div v-else-if="datiGeneraliItems.length">
      <!-- <h2>DATI GENERALI</h2> -->
      <b-table :per-page="datiGeneraliPerPage" :current-page="datiGeneraliCurrentPage" striped bordered hover
        :fields="datiGeneraliFields" :items="datiGeneraliItems" responsive :busy="false">

        <!-- <template #cell(selection)='data'>
          <b-form-radio v-model='selectedRow' name='selection' :value='data'></b-form-radio>
        </template> -->

        <!-- <template #cell(INDIRIZZO)="data">
          <p v-if="data.value.length >= 10" v-b-tooltip.hover :title="data.value">{{ formattedString(data.value)
          }}</p>
          <p v-else>{{ data.value }}</p>
        </template> -->
      </b-table>

      <div class="row justify-content-between mx-0 mt-0 mb-3 align-middle">
        <div class="text-right">
          <b-pagination :total-rows="datiGeneraliTotalRows" :per-page="datiGeneraliPerPage"
            v-model="datiGeneraliCurrentPage" class="my-0" />
        </div>
        <div class="text-right">
          <b-form-group description="Per pagina" class="mb-0">
            <b-form-select :options="pageOptions" v-model="datiGeneraliPerPage" />
          </b-form-group>
        </div>
      </div>
    </div>
    <div v-if="!loading" class="row">
      <h4 class='ml-4 my-4' style='float: left;'>Filtri ricerca movimenti</h4>
    </div>

    <b-form v-if="!loading" @submit="onSubmit" @reset="onReset" class="mb-5 pb-5">
      <div class="row">
        <!-- <b-form-group class="col-md-4 col-12" id="contabile">
            <label for="codiceContabile" style="float: left;">Codice RU</label>
            <b-form-input id="codiceContabile" v-model="ru" type="text" readonly></b-form-input>
          </b-form-group> -->

        <!-- <b-form-group class="col-md-4 col-12" id="contabile">
            <label for="matricola" style="float: left;">Matricola</label>
            <b-form-input id="matricola" v-model="matricola" type="text"
              placeholder="Codice matricola" readonly></b-form-input>
          </b-form-group> -->

        <!-- <b-form-group class="col-md-4 col-12" id="contabile">
            <label for="dal" style="float: left;">Dal</label>
            <b-form-input id="dal" v-model="dal" type="text" placeholder="Dal" readonly></b-form-input>
          </b-form-group> -->

        <!-- <b-form-group class="col-md-4 col-12" id="contabile">
            <b-form-input id="codiceContabile" v-model="form.codiceContabile" type="email"
              placeholder="Cod. contabile"></b-form-input>
          </b-form-group> -->

        <b-form-group class="col-md-2 col-12" id="matricola">
          <label class="ml-2" for="matricola" style="float: left;">Matricola</label>
          <b-form-select id="matricola" v-model="form.matricola" :options="matricola"
            @change="checkMatricole"></b-form-select>
        </b-form-group>

        <b-form-group class="col-md-2 col-12" id="dataDal">
          <label class="ml-2" for="dataDal" style="float: left;">Data dal</label>
          <b-form-datepicker id="dataDal" v-model="form.dataDal"
            :date-format-options="{ day: '2-digit', month: '2-digit', year: 'numeric' }" locale="it" class="mb-2"
            placeholder="" :disabled="disabled" :max="this.form.dataAl">
          </b-form-datepicker>
        </b-form-group>

        <b-form-group class="col-md-2 col-12" id="dataAl">
          <label class="ml-2" for="dataAl" style="float: left;">Data al</label>
          <b-form-datepicker id="dataAl" v-model="form.dataAl"
            :date-format-options="{ day: '2-digit', month: '2-digit', year: 'numeric' }" locale="it" class="mb-2"
            placeholder="" :disabled="disabled" :min="this.form.dataDal"></b-form-datepicker>
        </b-form-group>

        <b-form-group class="col-md-4 col-12" id="estrattoConto">
          <label class="ml-2" for="estrattoConto" style="float: left;">Tipo estratto conto</label>
          <b-form-select id="estrattoConto" v-model="estrattoConto" :options="estrattiConto"></b-form-select>
        </b-form-group>

        <b-form-group class="col-md-2 col-12" id="checkboxes" style="align-self: center; margin-top: 1.2rem;"
          v-slot="{ ariaDescribedby }">
          <b-form-checkbox-group v-model="form.checked" id="checkboxes" :aria-describedby="ariaDescribedby">
            <!-- <b-form-checkbox value="dataScadenza">Per data scadenza</b-form-checkbox> -->
            <b-form-checkbox value="partiteAperte" :disabled="disabled">Solo partite aperte</b-form-checkbox>
            <!-- <b-form-checkbox value="vigente" :disabled="estrattoConto != 2">Vigente</b-form-checkbox> -->
          </b-form-checkbox-group>
        </b-form-group>
        <!-- 
          <b-form-group class="col-md-4 col-12" id="format" label-for="format">
            <b-form-select id="format" v-model="form.formato" :options="formati"></b-form-select>
          </b-form-group> -->
      </div>
      <p class="ml-2 error-message">{{ matricoleMessage }}</p>
      <b-button style="float: right; margin-left: 0.5rem;" @click="onSubmit" variant="primary"
        :disabled="matricoleMessage != ''">Cerca</b-button>
      <b-button style="float: right;" type="reset" variant="outline-danger">Reset filtri</b-button>
    </b-form>
  </div>
</template>

<script>
/* eslint-disable */
import moment from 'moment'
import LoadingSpinner from '@/components/LoadingSpinner'

export default {
  components: {
    LoadingSpinner
  },
  data() {
    return {
      matricolaEsclusa: false,
      datiGeneraliItems: [],
      datiGeneraliFields: [
        { key: 'MATRICOLA', label: 'Matricola', sortable: true },
        { key: 'RU', label: 'Codice RU', sortable: true },
        { key: 'SEGMENTO_PATRIMONIO', label: 'Seg. patrimonio', sortable: true },
        { key: 'CODICE_FISCALE', label: 'Codice fiscale', sortable: true },
        { key: 'ANAGRAFICA', label: 'Anagrafica', sortable: true },
        { key: 'BU', label: 'Codice BU', sortable: true },
        { key: 'INDIRIZZO', label: 'Indirizzo', sortable: true },
        { key: 'SPECIFICA_INDIRIZZO', label: 'Spec. indirizzo', sortable: true },
        { key: 'CIVICO', label: 'Civico', sortable: true },
        { key: 'COMUNE', label: 'Comune', sortable: true },
        { key: 'DATA_STIPULA', label: 'Data stipula', sortable: true, formatter: (value) => { return value ? moment(value, moment.ISO_8601).format('DD/MM/YYYY') : '' } },
        { key: 'DATA_DECORRENZA', label: 'Data decorrenza', sortable: true, formatter: (value) => { return value ? moment(value, moment.ISO_8601).format('DD/MM/YYYY') : '' } },
        {
          key: 'DATA_CESSAZIONE', label: 'Data cessazione', sortable: true, formatter: (value) => { return value ? moment(value, moment.ISO_8601).format('DD/MM/YYYY') : '' }
        },
      ],
      loading: true,
      maxDate: '',
      matricoleMessage: '',

      datiGeneraliCurrentPage: 1,
      datiGeneraliPerPage: 10,
      datiGeneraliTotalRows: 0,
      estrattoConto: 1,

      pageOptions: [5, 10, 15],
      form: {},
      matricola: [],
      estrattiConto: [
        { value: 1, text: 'Estratto conto analitico' },
        { value: 2, text: 'Estratto conto per anno' },
        { value: 3, text: 'Versamenti' }
      ],
    }
  },

  async created() {
    this.loading = true
    await this.load()
    this.form.estrattoConto = this.estrattiConto[0].value;
    this.form.matricola = this.matricola[0]
    this.checkMatricole();
    this.loading = false
  },

  methods: {

    back() {
      this.$router.push({ name: 'home' })
    },

    async load() {
      try {
        await this.$store.dispatch('estratticonto/info')
        this.datiGeneraliItems = this.$store.state.estratticonto.info
        this.datiGeneraliTotalRows = this.datiGeneraliItems.length || 0
        this.valorizzaMatricoleOptions()
      } catch (err) {
        this.$ui.showError(err)
      }
    },

    async onSubmit() {
      let codiciRU = []
      let matricolaSelezionata = this.form.matricola
      this.datiGeneraliItems.forEach(element => {
        if (element.MATRICOLA == matricolaSelezionata) {
          codiciRU.push(element.RU)
        }
      });
      this.form.estrattoConto = this.estrattoConto
      let query = { ...this.form, matricola: matricolaSelezionata, codiciRU: codiciRU }
      this.$router.push({ name: 'estrattoconto', query: query })
    },


    onReset() {
      this.form.dataDal = null
      this.form.dataAl = null
      this.estrattoConto = this.estrattiConto[0].value;
      this.form.matricola = this.matricola[0];
      this.form.checked = []
      this.checkMatricole();
    },

    valorizzaMatricoleOptions() {
      this.datiGeneraliItems.forEach(element => {
        if (this.matricola.indexOf(element.MATRICOLA) < 0) {
          this.matricola.push(element.MATRICOLA)
        }
      });
    },

    checkMatricole() {
      let matricolaSelezionata = this.form.matricola
      this.datiGeneraliItems.forEach(el => {
        if (el.MATRICOLA == matricolaSelezionata) {
          if (el.IS_MATR_IN_TABELLA_ESCLUSE == 1) {
            if (el.DATA_INVALIDA == null) {
              this.$ui.showEcMessaggioInvalid()
              this.matricoleMessage = 'Estratto Conto non visualizzabile. Contattare gli sportelli Aequaroma.'
            } else {
              let invalidDate = moment(el.DATA_INVALIDA, moment.ISO_8601).format('DD/MM/YYYY')
              this.$ui.showEcMessaggioDataFiltered(invalidDate)
              this.matricoleMessage = ''
            }
          } else {
            if (!this.$store.state.auth.mexEcVisualizzato) {
              this.$ui.showEcMessaggio()
              this.$store.state.auth.mexEcVisualizzato = true
            }
            this.matricoleMessage = ''
          }
        }
      })
      return this.matricoleMessage
    },
  },
  computed: {
    disabled() {
      return this.estrattoConto == 2
    },
  },
}
</script>

<style>
.error-message {
  color: #862633;
  font-size: 20px;
  font-weight: 700;
  float: left;
}
</style>